import { isProduction } from '/src/utils';
import {
  SNAPSHOT_ADDON_50,
  SNAPSHOT_ADDON_100,
  SNAPSHOT_ADDON_200,
  SNAPSHOT_ADDON_UNLIMITED,
} from '/src/features/account/constants';

export function addCETag(tag) {
  const isProd = isProduction();

  if (window.CE2?.addTag && isProd) {
    window.CE2.addTag(tag);
  }
}

export function snapshotAddonListDetails(addon) {
  let detail;
  switch (addon) {
    case SNAPSHOT_ADDON_50:
      detail = { costPerMonth: 50, snapshots: 50, type: addon };
      break;
    case SNAPSHOT_ADDON_100:
      detail = { costPerMonth: 75, snapshots: 100, type: addon };
      break;
    case SNAPSHOT_ADDON_200:
      detail = { costPerMonth: 100, snapshots: 200, type: addon };
      break;
    case SNAPSHOT_ADDON_UNLIMITED:
      detail = { costPerMonth: 250, snapshots: 'unlimited', type: addon };
      break;
    default:
      detail = { costPerMonth: 0, snapshots: 0, type: false };
      break;
  }

  return detail;
}

export function formatPaymentMethodType(paymentMethodType) {
  if (!paymentMethodType) {
    return null;
  }

  const paymentMethodLabels = {
    card: 'Card',
    us_bank_account: 'US Bank Account',
    ach_debit: 'ACH Direct Debit',
    link: 'Link by Stripe',
    amazon_pay: 'Amazon Pay',
    paypal: 'PayPal',
    sepa_debit: 'SEPA Direct Debit',
    bacs_debit: 'Bacs Direct Debit',
    affirm: 'Affirm',
    afterpay_clearpay: 'Afterpay / Clearpay',
    alipay: 'Alipay',
    au_becs_debit: 'BECS Direct Debit',
    bancontact: 'Bancontact',
    boleto: 'Boleto',
    cashapp: 'Cash App Pay',
    customer_balance: 'Customer Balance',
    eps: 'EPS',
    giropay: 'Giropay',
    grabpay: 'GrabPay',
    ideal: 'iDEAL',
    klarna: 'Klarna',
    konbini: 'Konbini',
    oxxo: 'OXXO',
    p24: 'Przelewy24',
    paynow: 'PayNow',
    promptpay: 'PromptPay',
    revolut_pay: 'Revolut Pay',
    sofort: 'Sofort',
    wechat_pay: 'WeChat Pay',
  };

  return (
    paymentMethodLabels[paymentMethodType] ||
    paymentMethodType
      .split('_')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  );
}
